module.exports = __webpack_public_path__ + "media/images/flags/sm-7ca8ac543d88f764871657e450140e2a.svg";